module.exports = __webpack_public_path__ + "static/media/Classic.7db84742.png";